import React, { useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

import CommonStyle from "../common.module.css";
import PasswordStyle from "./Password.module.css";

const Password = ({ change, password, placeholder = "Password", name = "password" }) => {
  const [hidden, setHidden] = useState(true);

  const toggleShow = () => setHidden(!hidden);

  return (
    <div className={`${CommonStyle.password} ${PasswordStyle.password}`}>
      <input
        type={hidden ? "password" : "text"}
        placeholder={placeholder}
        name={name}
        onChange={change}
        value={password}
        className={`${CommonStyle.input}`}
      />
      <button className={`${PasswordStyle.toggler}`} onClick={toggleShow}>
        {hidden ? (
          <FontAwesomeIcon icon={faEyeSlash} color="grey" />
        ) : (
          <FontAwesomeIcon icon={faEye} color="grey" />
        )}
      </button>
    </div>
  );
}

export default Password;
